import React, { useRef, useState } from "react";
import { Box, useToast } from "@chakra-ui/react";
import Upload from "./../DeriveFile/Upload";
import FileTable from "./../DeriveFile/FileTable";
import {
  commitFile,
  getDeriveFileData,
  uploadFile,
} from "../../services/Agraphy";
import { showErrorToast, showSuccessToast } from "../../util/errorHandler";

export default function DerivedFile() {
  const [refreshKey, setRefreshKey] = useState(0);
  const toast = useToast();
  const isInitialLoad = useRef(true);
  const limit = 10; // Set a limit for pagination if needed
  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1);
    setCurrentPage(1); // Reset to page 1 on refresh
  };

  const handleFileUpload = async (file) => {
    try {
      const res = await uploadFile(file);
      if (!(res?.status >= 200 && res?.status < 300))
        throw new Error("Upload failed");

      showSuccessToast(toast, "Upload successful");

      handleRefresh(); // Trigger table data refresh
    } catch (err) {
      const backendMessage =
        err?.response?.data?.data || err?.response?.data?.message;
      showErrorToast(toast, backendMessage || err.message);
    }
  };
  const handleCommit = async (id) => {
    try {
      const res = await commitFile(id);
      if (!(res?.status >= 200 && res?.status < 300))
        throw new Error("Commit failed");
      showSuccessToast(toast, "Commit successful");
      handleRefresh(); // Trigger table data refresh
    } catch (err) {
      const backendMessage =
        err?.response?.data?.data || err?.response?.data?.message;
      showErrorToast(toast, backendMessage || err.message);
    }
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchFiles = async (page, searchText) => {
    setLoading(true);
    try {
      const result = await getDeriveFileData(page, limit, searchText);
      setData(result?.data?.data || []);
      setTotalPages(Math.ceil(result?.data?.total / limit));
      if (
        result?.data?.page_number &&
        parseInt(result?.data?.page_number) !== currentPage
      ) {
        setCurrentPage(parseInt(result?.data?.page_number));
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setData([]);
    }
    setLoading(false);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchText, setSearchText] = useState("");

  // Handle search button click
  const handleSearch = (searchTerm) => {
    if (searchTerm.trim()) {
      isInitialLoad.current = false; // Skip the first render
      setCurrentPage(1); // Reset to page 1 for a new search
      fetchFiles(1, searchTerm);
      setSearchText(searchTerm);
    }
  };
  const handleClear = () => {
    fetchFiles(1, "");
    setSearchText("");
  };

  // Handle page changes
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(parseInt(page));
    }
  };
  const columns = [
    { key: "file_name", label: "File Name" },
    { key: "type", label: "Type" },
    { key: "created_at", label: "Created At" },
    { key: "uploaded_by", label: "Uploaded By" },
    { key: "status", label: "Status" },
    { key: "derived_s3_url", label: "Download" }, // Optional custom render logic in FileTable
    { key: "error_file", label: "Invalid File" },
    { key: "log", label: "Log" }, // Opens the modal viewer
  ];
  return (
    <Box p={4}>
      <Upload
        onRefresh={handleRefresh}
        onFileUpload={handleFileUpload}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handlePageChange={handlePageChange}
        currentPage={currentPage}
        totalPages={totalPages}
      />
      <Box mt={4}>
        <FileTable
          refreshKey={refreshKey}
          fetchFiles={fetchFiles}
          data={data}
          currentPage={currentPage}
          searchText={searchText}
          loading={loading}
          columns={columns}
          onRefresh={handleRefresh}
          handleCommit={handleCommit}
        />
      </Box>
    </Box>
  );
}
